/**
 * Errori dell'API.
 *
 * I codici sono un'enumerazione chiusa perché l'interfaccia deve poter
 * reagire in modo diverso a "crediti finiti" e a "modulo non attivo": sono
 * due situazioni con due rimedi diversi, e un messaggio generico non aiuta
 * nessuno a uscirne.
 */
export type ApiErrorCode =
  | 'insufficient_credits'
  | 'module_inactive'
  | 'not_found'
  | 'validation'
  | 'invalid_credentials'
  | 'network'
  | 'unknown'

export class ApiError extends Error {
  readonly code: ApiErrorCode
  readonly status: number
  /** Dati aggiuntivi utili al rimedio, es. quanti crediti servivano. */
  readonly details: Record<string, unknown>

  constructor(
    code: ApiErrorCode,
    message: string,
    status = 400,
    details: Record<string, unknown> = {},
  ) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
    this.details = details
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError
}

/**
 * Messaggio da mostrare quando una richiesta fallisce. Dice cosa è successo
 * e come uscirne, nella voce dell'interfaccia — senza scusarsi e senza
 * nominare dettagli tecnici che chi legge non può usare.
 */
export function describeError(error: unknown): string {
  if (!isApiError(error)) {
    return 'Qualcosa non ha funzionato. Riprova fra un momento.'
  }

  switch (error.code) {
    case 'insufficient_credits':
      return `${error.message} Controlla il consumo in Utilizzo o aumenta il piano.`
    case 'module_inactive':
      return `${error.message} Attivalo in Impostazioni → Moduli.`
    case 'not_found':
      return 'Questo contenuto non esiste più. Aggiorna la pagina per vedere lo stato attuale.'
    case 'validation':
      return error.message
    case 'invalid_credentials':
      return error.message
    case 'network':
      return 'Nessuna risposta dal server. Controlla la connessione e riprova.'
    default:
      return 'Qualcosa non ha funzionato. Riprova fra un momento.'
  }
}
